import produce from 'immer';

// UTILS
import { toSelect } from 'utils/genericFunctions';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, AssuntosProblemas } from './types';

export const INITIAL_STATE: AssuntosProblemas = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AssuntosProblemas {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ASSUNTOS_PROBLEMAS__REQUEST: {
				break;
			}
			case Types.ASSUNTOS_PROBLEMAS__SUCCESS: {
				draft.status = action.payload.status;

				if (action.payload.data) {
					const select = toSelect(action.payload.data, 'nome', 'id');
					draft.data = select;
				} else {
					draft.data = [];
				}

				break;
			}
			case Types.ASSUNTOS_PROBLEMAS__FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.ASSUNTOS_PROBLEMAS__CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
